"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var datapoints_1 = require("./datapoints");
var deleteMailListRowsHelper_1 = require("./helpers/deleteMailListRowsHelper");
var deleteConversationService_1 = require("../services/deleteConversationService");
var restoreConversationService_1 = require("../services/restoreConversationService");
var composeStore_1 = require("owa-mail-compose-store/lib/store/composeStore");
var getUniqueConversationContextsForRowKey_1 = require("./helpers/getUniqueConversationContextsForRowKey");
var Store_1 = require("owa-mail-list-store/lib/store/Store");
var actionTypes_1 = require("owa-mail-store/lib/actions/actionTypes");
var undoActions = require("owa-mail-undo");
var folderNameToId_1 = require("owa-session-store/lib/utils/folderNameToId");
var owa_mail_strings_1 = require("owa-strings/owa-mail-strings");
var legacy_1 = require("satcheljs/lib/legacy");
var stitch_1 = require("satcheljs/lib/legacy/stitch");
var owa_mail_list_store_1 = require("owa-mail-list-store");
var owa_mail_actions_1 = require("owa-mail-actions");
/**
 * The action worker which handles deleting the given conversations
 * @param conversationActionContexts - action contexts
 * @param conversationIds - the conversation that need to be deleted
 * @param originalTableView - the table view the conversation should be deleted from
 * @param disposalType - the disposal type
 * @param actionSource - the action source
 */
exports.deleteConversationsWithoutConfirmDialog = legacy_1.action('deleteConversationsWithoutConfirmDialog', datapoints_1.default.deleteConversationDatapoint)(function deleteConversationsWithoutConfirmDialog(conversationActionContexts, originalTableViewId, disposalType, instrumentationContexts, actionSource) {
    var conversationIds = conversationActionContexts.map(function (conversationContext) { return conversationContext.conversationId; });
    var originalTableView = Store_1.default.tableViews.get(originalTableViewId);
    // raise stitch to delete conversation from list view and reading pane
    stitch_1.raiseAction(actionTypes_1.actionNames.DeleteConversationStoreUpdate)(conversationIds, originalTableView);
    undoActions.clearLastUndoableAction();
    var options = owa_mail_list_store_1.getMailboxInfo(originalTableView).requestOptions;
    var contextFolderId = owa_mail_list_store_1.getContextFolderIdForTable(originalTableView);
    // Make service request
    deleteConversationService_1.default(conversationActionContexts, contextFolderId, disposalType, options).then(function (response) {
        // After action completes successfully, add it to the undo stack
        // Only enable undo functionality when delete action was successful and if delete was not a SoftDelete
        if (response.ResponseClass == 'Success' && disposalType !== 'SoftDelete') {
            var deletedItemsFolderId_1 = folderNameToId_1.default('deleteditems');
            undoActions.addActionToUndoStack(function () {
                return restoreConversationService_1.default(conversationActionContexts, deletedItemsFolderId_1);
            });
        }
    });
    owa_mail_actions_1.userMailInteractionAction('Delete', instrumentationContexts);
});
/**
 * Initiates deleting of the given conversations
 * @param conversationRowKeys - the conversation that need to be deleted
 * @param originalTableViewId - the table view the conversation should be deleted from
 * @param isExplicitSoftDelete flag to indicate whether disposal type is soft delete
 * @param actionSource - the action source
 * @param state - some additional state required to complete the action
 */
exports.deleteConversationsFromTable = legacy_1.select({
    originalTableView: function (conversationId, originalTableViewId) {
        return Store_1.default.tableViews.get(originalTableViewId);
    },
})(function deleteConversationsFromTable(conversationRowKeys, originalTableViewId, isExplicitSoftDelete, instrumentationContexts, actionSource, state) {
    var confirmDialogStrings = {
        deleteNumberOfRows: owa_mail_strings_1.default.deleteNumberOfConversations,
        confirmDeleteRows: owa_mail_strings_1.default.confirmDeletingConversation,
    };
    return deleteMailListRowsHelper_1.default(conversationRowKeys, originalTableViewId, isExplicitSoftDelete, function (rowKeys, disposalType) {
        var conversationActionContexts = getUniqueConversationContextsForRowKey_1.default(rowKeys, originalTableViewId);
        exports.deleteConversationsWithoutConfirmDialog(conversationActionContexts, originalTableViewId, disposalType, instrumentationContexts, actionSource);
    }, isReplyingToOneOfConversations, confirmDialogStrings);
});
function isReplyingToOneOfConversations(conversationIds) {
    var replyConversationId = composeStore_1.default.defaultViewState && composeStore_1.default.defaultViewState.conversationId;
    return replyConversationId && conversationIds.indexOf(replyConversationId) >= 0;
}
//# sourceMappingURL=deleteConversations.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/deleteConversations.js
// module id = 3812
// module chunks = 62